// UrVenue listing status — timeline scroll of our events, each marked Listed
// (links to the live UrVenue listing) or Not listed. Read-only wrapper over
// the shared DistributionListings view: publishing to UrVenue goes through
// announce / sync-platforms and the per-event editor (the Edit link).

import { useParams } from 'react-router-dom';
import DistributionListings from './DistributionListings.jsx';

export default function UrVenueListings() {
  const { tenantSlug } = useParams();
  return (
    <DistributionListings
      title="UrVenue"
      platform="urvenue"
      listEndpoint="urvenue/listings"
      readOnly
      editHref={(e) => `/${tenantSlug}/event/${e.id}/urvenue`}
      notConnectedMsg="UrVenue is not connected for this tenant."
    />
  );
}
